var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"modal-chaoxian"},[_c('div',{staticClass:"chaoxian-content"},[_c('div',{staticClass:"chaoxian-header"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.textcontent)}})]),_c('div',{staticClass:"okbox"},[_c('button',{staticClass:"generate-button",on:{"click":_vm.closeModal}},[_vm._v(" OK ")])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }